import apiClient from "@/api/client";

export type PrimaryContractType = "uop" | "uz" | "b2b";

export interface PrimaryEmploymentContract {
  id: string;
  employee: string;
  employee_name: string;
  contract_type: PrimaryContractType;
  contract_type_display: string;
  effective_from: string;
  effective_to: string | null;
  is_active: boolean;
  note: string;
  contract_scan: string | null;
  contract_scan_url: string | null;
  contract_scan_detail: {
    id: string;
    original_filename: string;
    content_type: string;
    size_bytes: number | null;
    url: string | null;
  } | null;
  created_by: string | null;
  created_by_name: string | null;
  created_at: string;
  updated_at: string;
}

export interface PrimaryContractInput {
  employee: string;
  contract_type: PrimaryContractType;
  effective_from: string;
  effective_to?: string | null;
  is_active?: boolean;
  note?: string;
}

const wrap = <T,>(res: { data: { data: T } }): T => res.data.data;

export const primaryContractsApi = {
  list: (employee?: string) =>
    apiClient
      .get<{ data: PrimaryEmploymentContract[] }>("/ceo/primary-contracts/", {
        params: employee ? { employee } : undefined,
      })
      .then(wrap),

  create: (payload: PrimaryContractInput) =>
    apiClient
      .post<{ data: PrimaryEmploymentContract }>("/ceo/primary-contracts/", payload)
      .then(wrap),

  update: (id: string, payload: Partial<PrimaryContractInput>) =>
    apiClient
      .patch<{ data: PrimaryEmploymentContract }>(`/ceo/primary-contracts/${id}/`, payload)
      .then(wrap),

  remove: (id: string) =>
    apiClient.delete(`/ceo/primary-contracts/${id}/`).then(() => undefined),

  setScan: (id: string, fileId: string | null) =>
    apiClient
      .patch<{ data: PrimaryEmploymentContract }>(`/ceo/primary-contracts/${id}/`, {
        contract_scan: fileId,
      })
      .then(wrap),
};
